"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var SpecialInstructions = function SpecialInstructions(_ref) {
  var specialInstructions = _ref.specialInstructions,
      onSpecialInstructionsChange = _ref.onSpecialInstructionsChange,
      _ref$showDivider = _ref.showDivider,
      showDivider = _ref$showDivider === void 0 ? true : _ref$showDivider,
      checkoutDisabled = _ref.checkoutDisabled;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "item-cart-special-instructions"
  }, showDivider && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Divider, null), /*#__PURE__*/_react["default"].createElement("h5", null, "SPECIAL INSTRUCTIONS"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.TextArea, {
    value: specialInstructions,
    onChange: onSpecialInstructionsChange,
    disabled: checkoutDisabled
  }));
};

var _default = SpecialInstructions;
exports["default"] = _default;